<template>
  <div
    class="d-flex align-center"
    :class="[
      isAndroidOrIos ? 'fixedTopMenuBarWithExtraSpace' : 'fixedTopMenuBar',
      isIos ? 'iosMoveTopMenuBar' : '',
    ]"
  >
    <!-- ! TOOLBAR -->
    <AppToolbar
      :nav-drawer="navDrawer"
      :is-hide-all-but-locale="isHideAllButLocale"
      @logout="handleLogout"
      @clickToOpenTheDrawer="clickToOpenTheDrawer"
    ></AppToolbar>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import AppToolbar from '@/components/AppToolbar/AppToolbar.vue';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';

const componentOptions: ComponentOptions = {
  name: 'HeaderComponent',
  components: {
    AppToolbar,
  },
  props: {
    navDrawer: {
      type: Boolean,
      required: true,
    },
    isHideAllButLocale: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isAndroidOrIos() {
      return CapacitorFacade.isAndroid() || CapacitorFacade.isIos();
    },
    isIos() {
      return CapacitorFacade.isIos();
    },
  },
  methods: {
    handleLogout() {
      this.$emit('logout');
    },
    clickToOpenTheDrawer() {
      this.$emit('clickToOpenTheDrawer');
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.fixedTopMenuBar {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 11;
  padding-top: env(safe-area-inset-top);
  /* Ensures padding below the status bar/notch */
}
.fixedTopMenuBarWithExtraSpace {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 11;
  padding-top: 35px !important;
  background-color: rgb(238, 238, 238);
  padding-top: env(safe-area-inset-top); /* Ensures padding below the status bar/notch */
}
.iosMoveTopMenuBar {
  top: -35px !important;
  padding-top: 65px !important;
}
</style>
